import { useEffect, useState } from "react";
import CoreLayout from "../../layouts/core-layout";
import AccountLayout from "./account-layout";
//Axios Instance
import Swal from "sweetalert2";
//Multi language
import { useTranslation } from "react-i18next";
import { sendDeleteOwnAccountRequest } from "../../api/DeleteDemandApi";
import { useAuth } from "react-oidc-context";
import i18n from "../../i18n";
export const DataDeletion = () => {
  const { t } = useTranslation(); // Multi Language

  const [confirmChecked, setConfirmChecked] = useState(false);

  const auth = useAuth()

  const handleClick = async () => {
    try {
      await sendDeleteOwnAccountRequest();
      Swal.fire({
        title: t("Votre compte a bien été supprimé. Vous allez être déconnecté."),
        icon: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 4000,
      });
      setTimeout(() => {
        auth.signoutRedirect()
      }, 4000);
    } catch (error) {
      console.error("Erreur lors de la tentative de suppression du compte", error);
      // Gérer l'erreur de manière appropriée
    }
  };

  return (
    <CoreLayout template="main">
      <AccountLayout>
        <div className="card">
          <div
            className="card-header border-0 cursor-pointer"
            role="button"
            data-bs-toggle="collapse"
            data-bs-target="#kt_account_deactivate"
            aria-expanded="true"
            aria-controls="kt_account_deactivate"
          >
            <div className="card-title m-0">
              <h3 className="fw-bolder m-0">
                {t("core:pages.account.AccountEdit.deleteAccount.profile.label")}
              </h3>
            </div>
          </div>


          <div className="card-body border-top p-9">
            <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6">
              <span className="svg-icon svg-icon-2tx svg-icon-warning me-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    opacity="0.3"
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="10"
                    fill="black"
                  />
                  <rect
                    x="11"
                    y="14"
                    width="7"
                    height="2"
                    rx="1"
                    transform="rotate(-90 11 14)"
                    fill="black"
                  />
                  <rect
                    x="11"
                    y="17"
                    width="2"
                    height="2"
                    rx="1"
                    transform="rotate(-90 11 17)"
                    fill="black"
                  />
                </svg>
              </span>
              <div className="d-flex flex-stack flex-grow-1">
                <div className="fw-bold">
                  <div className="fs-6 text-gray-700">
                    {t("core:pages.account.AccountEdit.deleteAccount.profile.update.warning")}
                  </div>
                </div>
              </div>
            </div>


          </div>

          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button
              type="button"
              className="btn btn-primary px-6"
              onClick={() => window.open(`${process.env.REACT_APP_OIDC_AUTHORITY}/account?kc_locale=${i18n.language}`, '_blank')}
            >
              {t(
                "core:pages.account.AccountEdit.deleteAccount.profile.update.button"
              )}{" "}
            </button>
          </div>
        </div>
        <div className="card">
          <div
            className="card-header border-0 cursor-pointer"
            role="button"
            data-bs-toggle="collapse"
            data-bs-target="#kt_account_deactivate"
            aria-expanded="true"
            aria-controls="kt_account_deactivate"
          >
            <div className="card-title m-0">
              <h3 className="fw-bolder m-0">
                {t("core:pages.account.AccountEdit.deleteAccount.title")}
              </h3>
            </div>
          </div>
          <div id="kt_account_settings_deactivate" className="collapse show">
            <form id="kt_account_deactivate_form" className="form">
              <div className="card-body border-top p-9">
                <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6">
                  <span className="svg-icon svg-icon-2tx svg-icon-warning me-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <rect
                        opacity="0.3"
                        x="2"
                        y="2"
                        width="20"
                        height="20"
                        rx="10"
                        fill="black"
                      />
                      <rect
                        x="11"
                        y="14"
                        width="7"
                        height="2"
                        rx="1"
                        transform="rotate(-90 11 14)"
                        fill="black"
                      />
                      <rect
                        x="11"
                        y="17"
                        width="2"
                        height="2"
                        rx="1"
                        transform="rotate(-90 11 17)"
                        fill="black"
                      />
                    </svg>
                  </span>
                  <div className="d-flex flex-stack flex-grow-1">
                    <div className="fw-bold">
                      <h4 className="text-gray-900 fw-bolder">
                        {t(
                          "core:pages.account.AccountEdit.deleteAccount.warning"
                        )}
                      </h4>
                      <div className="fs-6 text-gray-700">
                        {t("core:pages.account.AccountEdit.deleteAccount.text")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-check form-check-solid fv-row">
                  <input
                    name="deactivate"
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="deactivate"
                    onChange={(e) => setConfirmChecked(e.target.checked)}
                    checked={confirmChecked}
                  />
                  <label
                    className="form-check-label fw-bold ps-2 fs-6"
                    htmlFor="deactivate"
                  >
                    {t(
                      "core:pages.account.AccountEdit.deleteAccount.confirmCheckbox"
                    )}
                  </label>
                </div>
              </div>

              <div className="card-footer d-flex justify-content-end py-6 px-9">
                <button
                  type="button"
                  className="btn btn-primary px-6"
                  disabled={!confirmChecked}
                  onClick={handleClick}
                >
                  {" "}
                  {t(
                    "core:pages.account.AccountEdit.deleteAccount.button"
                  )}{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </AccountLayout>
    </CoreLayout>
  );
};
